<script setup lang="ts">

import { faChevronDown, faCloudArrowUp, faFileLines } from '@fortawesome/pro-regular-svg-icons'

import { AppIcon } from '@shared/ui/icons'
import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnPrimary } from '@shared/ui/buttons'

import { useDisciplineFilesSendMenu } from '../model/discipline-files-send-menu.hook'

defineOptions({
  name: 'DisciplineFilesSendMenu',
})

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  canManageFiles,
  canManageDisciplines,
  toggle,
  openSendFiles,
  openCertificate,
} = useDisciplineFilesSendMenu()
</script>

<template>
  <div
    v-if="canManageFiles || canManageDisciplines"
    ref="containerRef"
    class="discipline-files-send-menu"
  >
    <BtnPrimary
      text="Send file"
      color="emerald"
      @click="toggle"
    >
      <template #iconRight>
        <AppIcon :icon="faChevronDown" />
      </template>
    </BtnPrimary>
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="discipline-files-send-menu__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          v-if="canManageDisciplines"
          text="Generate certificate"
          color="blue"
          :prepend-icon="faCloudArrowUp"
          @click="openCertificate"
        />
        <AppDropdownItem
          v-if="canManageFiles"
          text="Send files"
          color="blue"
          :prepend-icon="faFileLines"
          @click="openSendFiles"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineFilesSendMenu.scss" />
